import React, {useEffect, useReducer} from "react";
import LightCard from "../../../../../../../../components/card/LightCard";
import StaffInfo from "../../StaffInfo";
import Error404 from "../../../../../../../Error404";
import {
    lineupGetDataAPI,
    saveLineupAPI,
} from "../../../../../../../../services/api/projectCurrent";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import DarkCard from "../../../../../../../../components/card/DarkCard";
import { Link } from "react-router-dom";
import { TxtTitles } from "../../../../../../../../helpers/breadCrumbs";
import CategoryList from "./CategoryList";
import {Input} from "../../../../../../../../components/ui/Input";
import {Button} from "../../../../../../../../components/ui/Button";
import {Colors} from "../../../../../../../../components/theme";
import PopupWithContext from "../../../../../../../../components/ui/Popup/PopupWithContext";
import SavingPopupContext from "../../../../../../../../components/ui/Popup/SavingPopupContext";
import OkBtnPopupContext from "../../../../../../../../components/ui/Popup/OkBtnPopupContext";
import RedHeader from "../../../../../../../../components/ui/RedBgTitleHeader";

const INITIAL_POPUP = {show: false, formName: '', title: '', variant: 'error', message: ''}

const INITIAL_STATE = {
    returnPatch: "",
    projectName: "",
    popup: INITIAL_POPUP,
    staff: {},
    musiciansList: {},
    musiciansListFiltered: {},
    musicians: {},
    filter_musicians: "all",
    users: [],
    othersMusicians: {},
    othersMusiciansListFiltered: [],
}

// {value: "Tutti", label: t("effectif.composition") + "*", color: '#00ace6'},
// {value: 'Tutti', label: 'Tutti', color: '#00ace6', isDisabled: true}


const lineupReducer = (state, action) => {
    switch (action.type) {
        case "INITIAL_DATA":
            return {...state,
                projectName: action.dataset.project_name,
                returnPatch: action.returnPatch,
                staff: action.dataset.staff,
                musicians: action.dataset.musicians,
                musiciansList: action.dataset.musiciansList,
                users: action.dataset.users,
                othersMusicians: action.dataset.othersMusicians,
            };

        case "SET_MUSICIAN":
            const state_musicians_copy = structuredClone(state.musicians)
            let instrument = state_musicians_copy[action.dataset.instrument]

            if (instrument) {
                const position_test = instrument.findIndex(el => el.position === action.dataset.value.position)
                if (action.dataset.value.value === "0000") {
                    if (position_test !== -1) instrument.splice(position_test, 1)
                } else if (position_test !== -1) { // zamiana muzyka na pozycji
                    instrument.splice(position_test, 1, action.dataset.value)
                } else {
                    instrument = [...instrument, action.dataset.value]
                    state_musicians_copy[action.dataset.instrument] = instrument
                }
                return {...state, musicians: state_musicians_copy}
            } else {
                return {
                    ...state,
                    musicians: {
                        ...state.musicians,
                        [action.dataset.instrument]: [action.dataset.value]
                    },
                }
            }

        case "MUSICIAN_LIST_FILTERED":
            return {
                ...state,
                musiciansListFiltered: action.musiciansListFiltered,
                othersMusiciansListFiltered: action.othersMusiciansListFiltered
            };

        case "SET_FILTER_MUSICIAN":
            return {...state, filter_musicians: action.value};

        case "SAVE_TO_DB":
            return {...state, popup: {
                    show: true,
                    title: 'Save to db',
                    message: "Czy zapisać dane do bazy?",
                    formName: "globalSave",
                    variant: 'editF',
                    leftBtn: "common.button.save",
                    rightBtn: "common.button.cancel",
                }}

        case "SET_OTHERS_MUSICIANS":
            return {...state, othersMusicians: {...state.othersMusicians, [action.position]: action.dataSet} }

        case "SET_POPUP":
            return {...state, [action['key']]: action.dataset};

        default:
            throw new Error('Unknown action: ' + action);
            return state
    }
}


export default function LineupEdit() {
    const [state, dispatch] = useReducer(lineupReducer, INITIAL_STATE, undefined);
    const params = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        const get_DataAPI = async () => {
            const response = await lineupGetDataAPI(params.id)
            if (response.status === 200) {
                dispatch({
                    type: "INITIAL_DATA",
                    dataset: response.data,
                    returnPatch: sessionStorage.getItem('project-current-return'),
                })
            } else return <Error404/>
        }
        get_DataAPI()

    }, [])

    useEffect(() => {
        return () => sessionStorage.removeItem('project-current-return')
    }, [location])

    useEffect(() => {
        const users_filtered = state.users.filter(user => {
            const site_filter = (state.filter_musicians === "all" || state.filter_musicians === user.musician_category)
            if (!site_filter) return false

            // czy jest wybrany w musicians
            const test_musician_selected = Object.values(state.musicians).some(musician_sel => {
                return musician_sel.some(musician => musician.value === user.value)
            })
            // czy jest wybrany w othersMusicians
            const test_otherMusician_selected =  Object.values(state.othersMusicians).some(musician => {
                if (musician && musician.musician) {
                    return musician.musician.value === user.value
                }
                return false
            })
            return !test_musician_selected && !test_otherMusician_selected
        })

        const musiciansListFiltered = {}
        Object.entries(state.staff).forEach(([instr, count]) => {
            if (+count >0) {
                const musicians_with_instrument = users_filtered.filter(user => user.instruments.find(instrument => instrument.label === instr))
                musiciansListFiltered[instr] = musicians_with_instrument.map(musician => {
                    return {
                        value: musician.value,
                        label: musician.label,
                        musician_category: musician.musician_category
                    }
                })
            }
        })

        dispatch({
            type: "MUSICIAN_LIST_FILTERED",
            musiciansListFiltered: musiciansListFiltered,
            othersMusiciansListFiltered: users_filtered
        })
    }, [state.musicians, state.filter_musicians, state.othersMusicians])

    const handlePopup = async (opt) => {
        if (state.popup.formName === "globalSave" && opt.type === 'save') {
            // zapis do bazy
            const stateCopy = structuredClone({...state.musicians, others: state.othersMusicians})

            const response = await saveLineupAPI(params.id, stateCopy)
            if (response && response.status === 200) {
                dispatch({
                    type: "SET_POPUP",
                    dataset: {
                        show: true,
                        variant: "editF",
                        title: t("OK"),
                        message: "Zaktualizowano wpisy w bazie.",
                        type: "formular",
                        okBtn: t("common.button.ok"),
                        formName: "OkBtn",
                    },
                    key: "popup"
                })
            } else {
                dispatch({
                    type: "SET_POPUP",
                    dataset: {
                        show: true,
                        variant: "error",
                        title: t("OK"),
                        message: "BŁĄD w aktualizacji wpisów w bazie.",
                        type: "formular",
                        okBtn: t("common.button.ok"),
                        formName: "OkBtn",
                    },
                    key: "popup"
                })
            }
        } else {
            dispatch({type: "SET_POPUP", dataset: INITIAL_POPUP, key: "popup"})
            console.log("popup not show and navigate...", state.returnPatch)
        }
    }

    const popupForm = {
        globalSave: <SavingPopupContext
            handlePopup={handlePopup}
            saveBtn={t(state.popup.leftBtn)}
            cancelBtn={t(state.popup.rightBtn)}
        />,
        OkBtn: <OkBtnPopupContext okBtn={t(state.popup.okBtn)} handlePopup={handlePopup} />,
    }

    return (<>
        {state.popup.show
            ? <PopupWithContext
                variant={state.popup.variant}
                title={t(state.popup.title)}
                message={t(state.popup.message)}
            >
                {popupForm[state.popup.formName]}
            </PopupWithContext>
            : <>
            <DarkCard classNames='mb-3 row'>
                <p className="m-0 p-0 breadcrumbs">
                    <span className="txt">{t("menu.projects", {ns: 'menu'})}</span>&#8201;&#9656;&#8201;
                    <Link to={'/projects/currents-list'}>{t("menu.current_projects", {ns: 'menu'})}</Link>&#8201;&#9656;&#8201;
                    <Link
                        to={'/projects/current/' + params.id}>{t("breadcrumbs.project_title")} P{params.id}</Link>&#8201;&#9656;&#8201;
                    <span className="txt">{t("common.button.edit_lineup")}</span>
                </p>
            </DarkCard>
            <DarkCard className='mb-3 px-0'>
                <TxtTitles>{t("project.project_name_title")}</TxtTitles>
                <h1 className='mb-3 mt-0 p-0' style={{marginTop: '-5px'}}>
                    {state.projectName}
                </h1>

                {/*STAFF*/}
                <LightCard>
                    <StaffInfo staff={state.staff} conductor={state.staff.conductor} others={state.staff.others} />
                </LightCard>

                {/* FILTERS */}
                <LightCard classNames={'mt-4'}>
                    <div className='row px-2'>
                        <b>{t("project.lineup.musician_filter_text")}</b>
                        <Input
                            type='radio'
                            name='musicians-filter'
                            options={[
                                {value: "all", label: t("project.lineup.all_mus_type")}, 
                                {value: "regular", label: t("project.lineup.regular_mus_type")}, 
                                {value: "renfort", label: t("project.lineup.reinforcement_mus_type")}]}
                            value={state.filter_musicians}
                            onChange={val => dispatch({type: "SET_FILTER_MUSICIAN", value: val})}
                        />
                    </div>
                </LightCard>

                {/*CATEGORY INSTRUMENTS AND MUSICIANS*/}
                <CategoryList
                    staff={state.staff}
                    musiciansList={state.musiciansListFiltered}
                    musicians={state.musicians}
                    dispatch={dispatch}
                    otherMusiciansList={state.othersMusiciansListFiltered}
                    othersMusicians={state.othersMusicians}
                />

                {/* SAVE AND CANCEL BUTTONS */}
                <div className="mt-3">
                    <Button
                        className='me-4'
                        variant='round'
                        style={{backgroundColor: `${Colors.green}`}}
                        name='save'
                        onClick={() => dispatch({type: "SAVE_TO_DB"})}>
                        {t("common.button.save")}
                    </Button>

                    <Button
                        className='me-4'
                        variant='round'
                        styling="bordered"
                        name='cancel'
                        onClick={() => navigate(state.returnPatch)}>
                        {t("common.button.cancel")}
                    </Button>
                </div>

            </DarkCard>
        </>}
    </>)
}